import {useCallback, useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {MoleculeTextareaSizes} from '@s-ui/react-molecule-textarea-field'
import FormContactSeller from '@adv-mt/mt-form-contact-seller'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

const BASE_CLASS = 'mt-NetDrawer-contactFrom'

const NetContactForm = ({ad = {}, message, extendedTrackingData = {}, onClose, pageName}) => {
  const {domain} = useContext(Context)

  const {track} = useAnalyticsTrack()

  const config = domain.get('config')
  const {LIST_TRIGGERED_EVENT, LEAD_TYPES, AUTHENTICATION_HIT_INFORMATIONS_2} = config.get('tracking')

  const handleOnContact = useCallback(() => {
    track({
      event: LIST_TRIGGERED_EVENT,
      data: {
        ...extendedTrackingData,
        lead_type: LEAD_TYPES.NET_AD_DETAIL_EMAIL
      }
    })
  }, [LEAD_TYPES.NET_AD_DETAIL_EMAIL, LIST_TRIGGERED_EVENT, extendedTrackingData, track])

  return (
    <div className={BASE_CLASS}>
      <FormContactSeller
        ad={ad}
        adId={ad.adId}
        contractId={ad.contractId}
        isModal={true}
        pageName={pageName}
        province={ad.mainProvince}
        showLabels={false}
        showSellerCallLinkButton={false}
        initialMessage={message}
        textareaSize={MoleculeTextareaSizes.LONG}
        onContact={handleOnContact}
        authenticationHitInformation2={AUTHENTICATION_HIT_INFORMATIONS_2.NET}
      />
    </div>
  )
}

NetContactForm.displayName = 'NetContactForm'

NetContactForm.propTypes = {
  ad: PropTypes.object.isRequired,
  message: PropTypes.string,
  extendedTrackingData: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  pageName: PropTypes.string
}

export default NetContactForm
